import { render, staticRenderFns } from "./HeadTeacherReferrerList.vue?vue&type=template&id=fa782dd2&scoped=true&"
import script from "./HeadTeacherReferrerList.vue?vue&type=script&lang=js&"
export * from "./HeadTeacherReferrerList.vue?vue&type=script&lang=js&"
import style0 from "./HeadTeacherReferrerList.vue?vue&type=style&index=0&id=fa782dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa782dd2",
  null
  
)

export default component.exports